var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSelector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.1875C5.5875 15.1875 2.8125 12.4125 2.8125 9C2.8125 5.5875 5.5875 2.8125 9 2.8125C12.4125 2.8125 15.1875 5.5875 15.1875 9C15.1875 12.4125 12.4125 15.1875 9 15.1875ZM9 3.9375C6.21 3.9375 3.9375 6.21 3.9375 9C3.9375 11.79 6.21 14.0625 9 14.0625C11.79 14.0625 14.0625 11.79 14.0625 9C14.0625 6.21 11.79 3.9375 9 3.9375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.8125C7.4475 11.8125 6.1875 10.5525 6.1875 9C6.1875 7.4475 7.4475 6.1875 9 6.1875C10.5525 6.1875 11.8125 7.4475 11.8125 9C11.8125 10.5525 10.5525 11.8125 9 11.8125ZM9 7.3125C8.07 7.3125 7.3125 8.07 7.3125 9C7.3125 9.93 8.07 10.6875 9 10.6875C9.93 10.6875 10.6875 9.93 10.6875 9C10.6875 8.07 9.93 7.3125 9 7.3125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5625C8.6925 3.5625 8.4375 3.3075 8.4375 3V1.5C8.4375 1.1925 8.6925 0.9375 9 0.9375C9.3075 0.9375 9.5625 1.1925 9.5625 1.5V3C9.5625 3.3075 9.3075 3.5625 9 3.5625Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.5625H1.5C1.1925 9.5625 0.9375 9.3075 0.9375 9C0.9375 8.6925 1.1925 8.4375 1.5 8.4375H3C3.3075 8.4375 3.5625 8.6925 3.5625 9C3.5625 9.3075 3.3075 9.5625 3 9.5625Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.0625C8.6925 17.0625 8.4375 16.8075 8.4375 16.5V15C8.4375 14.6925 8.6925 14.4375 9 14.4375C9.3075 14.4375 9.5625 14.6925 9.5625 15V16.5C9.5625 16.8075 9.3075 17.0625 9 17.0625Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.5625H15C14.6925 9.5625 14.4375 9.3075 14.4375 9C14.4375 8.6925 14.6925 8.4375 15 8.4375H16.5C16.8075 8.4375 17.0625 8.6925 17.0625 9C17.0625 9.3075 16.8075 9.5625 16.5 9.5625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSelector);
export default __webpack_public_path__ + "static/media/location-selector.b7e4b12b46c4483fd689e67cc52fb782.svg";
export { ForwardRef as ReactComponent };